export default __webpack_public_path__ + "static/media/gu.8e05e863.jpg";